import { jsx as _jsx } from "react/jsx-runtime";
import { useUIComponents } from "@bluelibs/x-ui";
export function AdminContent(props) {
    const UIComponents = useUIComponents();
    return (_jsx(UIComponents.ErrorBoundary, { children: props.children }));
}
